import { useCallback, useEffect, useState } from 'react';
import { useChat } from '../../../../../libs/hooks';
import { IChatMessage, UserFeedback } from '../../../../../libs/models/ChatMessage';
import { useAppDispatch } from '../../../../../redux/app/hooks';
import { setNotifications } from '../../../../../redux/features/app/appSlice';
import { NOTIFICATION_TEMPLATES } from '../../Notifications/NotificationConstants';

interface IUserFeedbackProps {
    message: IChatMessage;
    userFeedback?: UserFeedback;
    onFeedbackCommentProvided: () => void;
}

export const UserFeedbackComment: React.FC<IUserFeedbackProps> = ({
    message,
    userFeedback,
    onFeedbackCommentProvided,
}) => {
    const chat = useChat();
    const dispatch = useAppDispatch();
    const [feedbackComment, setFeedbackComment] = useState<string | undefined>();
    const [feedbackSubmitted, setFeedbackSubmitted] = useState<boolean>(false);
    const [feedbackCancelled, setFeedbackCancelled] = useState<boolean>(false);
    const [startHide, setStartHide] = useState<boolean>(false);

    useEffect(() => {
        if (feedbackSubmitted) {
            const timer = setTimeout(() => {
                setStartHide(true);
                const hideTimer = setTimeout(() => {
                    //onFeedbackCommentProvided();
                    clearTimeout(hideTimer);
                }, 600);
                clearTimeout(timer);
            }, 3000);
        }
    }, [feedbackSubmitted, onFeedbackCommentProvided]);

    const onUserFeedbackProvided = useCallback(async () => {
        setFeedbackSubmitted(true);
        dispatch(setNotifications([NOTIFICATION_TEMPLATES.FEEDBACK]));
        if (message.id && userFeedback) {
            await chat.editMessage(message.chatId, message.id, userFeedback.type, feedbackComment);
        }
    }, [message, userFeedback, chat, feedbackComment]);

    const getFeedbackContent = () => {
        if (feedbackCancelled) {
            return <></>;
        } else if (feedbackSubmitted) {
            return (
                <div
                    className={`flex items-center gap-x-2 text-slate-500 ${startHide ? 'transition-all duration-200 opacity-0 h-0' : ''}`}>
                    <span>Thank you for your feedback</span>
                </div>
            );
        } else {
            return (
                <>
                    <textarea
                        placeholder="Tell us more..."
                        onChange={(event) => {
                            setFeedbackComment(event.target.value);
                        }}
                        className="block w-full resize-none rounded-xl border border-slate-300 focus:border-none bg-slate-50 p-4 mt-4 pr-10 mr-10 text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-blue-600 dark:bg-slate-900 dark:text-slate-200 dark:placeholder-slate-400 dark:focus:ring-blue-600 sm:text-base"
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' && !event.shiftKey) {
                                event.preventDefault();
                                void onUserFeedbackProvided();
                            }
                        }}
                    />
                    <div className="flex w-full flex-row justify-end gap-x-2 text-slate-500 mt-4">
                        <button
                            className={`${!feedbackComment ? 'text-slate-400 border border-slate-500' : 'text-primary-50 bg-primary-600'} inline-flex justify-center rounded-lg p-2 shadow-md`}
                            disabled={!feedbackComment}
                            title="add feedback above to submit"
                            onClick={() => {
                                void onUserFeedbackProvided();
                            }}>
                            <span className="px-2 text-sm">Submit feedback</span>
                        </button>
                        {/* cancel button */}
                        <button
                            className="text-primary-50 inline-flex justify-center rounded-lg p-2 bg-primary-600 shadow-md"
                            title="cancel"
                            onClick={() => {
                                setFeedbackCancelled(true);
                            }}>
                            <span className="px-2 text-sm">Cancel</span>
                        </button>
                    </div>
                </>
            );
        }
    };
    return <div>{getFeedbackContent()}</div>;
};
